module.exports = __webpack_public_path__ + "static/media/aruushi_kaur.8d546ddc.png";